import { classNames } from '@repo/ui/src/utils/classNames';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

export type ChevronDirection = 'up' | 'down' | 'left' | 'right';

export interface ChevronIconProps extends IconWrapperProps {
  color?: string;
  direction?: ChevronDirection;
}

const rotationClasses: Record<ChevronDirection, string> = {
  up: 'rotate-0',
  down: 'rotate-180',
  right: 'rotate-90',
  left: '-rotate-90',
};

const ChevronIcon = ({
  color = 'currentColor',
  className,
  direction = 'up',
  ...rest
}: ChevronIconProps) => (
  <IconWrapper
    viewBox="0 0 24 24"
    className={classNames(
      'transition-all duration-500 w-full h-full',
      rotationClasses[direction],
      className,
    )}
    title="Chevron"
    {...rest}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m4.685 14 8-8 8 8"
    />
  </IconWrapper>
);

export default ChevronIcon;
